// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TerminationRepoConfig from "./TerminationRepoConfig.bs.js";
import * as CommonRepoConfig$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/CommonRepoConfig.bs.js";

var dummyInfoResponse = {
        termination_info: {
          driver_termination_history: [{
          termination_admin: "TEST@xyz.com",
          termination_description: "Bad behaviour",
          termination_duration: "5 months",
          termination_end_time: "Present",
          termination_start_time: "2018-12-21 19:26:31 +0530",
          termination_status: "terminated",
          termination_comment: "the partner was doing shady stuff"
        }],
        active_status: "active"
        }
      };

var dummyReasonResponse = {"result":[
        {
          "id":13,
          "description":"Driver Suspended due to breach in Monthly Suspension Threshold"
        },
        {
          "id":10,
          "description":"No order for last 15 days"
        },
        {
          "id":9,
          "description":"Not reachable for last 5 consecutive times"
        },
        {
          "id":8,
          "description":"Not Logged in for last 15 days"
        },
        {
          "id":7,
          "description":"Driver left and owner to find a new driver"
        },
        {
          "id":4,"description":"Inappropriate behavior"
        },
        {
          "id":3,"description":"Vehicle breakdown"
        },
        {
          "id":2,"description":"Driver is very rude"
        },
        {
          "id":1,
          "description":"Driver is not punctual"
        },
        {
          "id":15,
          "description":"Partner suspended due to breach of delay penalty count"
        },
        {
          "id":16,"description":"Partner suspended due to breach of cancel order penalty count"
        }]
      };

var dummyTerminateDriverResponse = {
        "status": 200,
        "message": "The driver has been terminated"
      };

var dummyReactivateDriverResponse = {
        "status": 200,
        "message": "The driver has been reactivated"
      };

function fetchTerminationInfo(_msisdn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyInfoResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TerminationRepoConfig.TerminationInfoResponseConverter.execute, result);
                        });
            });
}

function fetchTerminationReasons(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyReasonResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TerminationRepoConfig.TerminationReasonsResponseConverter.execute, result);
                        });
            });
}

function terminateDriver(_msisdn, _reason, _comment, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyTerminateDriverResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

function reactivateDriver(_msisdn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyReactivateDriverResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

var TerminationRepo = {
  dummyInfoResponse: dummyInfoResponse,
  dummyReasonResponse: dummyReasonResponse,
  dummyTerminateDriverResponse: dummyTerminateDriverResponse,
  dummyReactivateDriverResponse: dummyReactivateDriverResponse,
  fetchTerminationInfo: fetchTerminationInfo,
  fetchTerminationReasons: fetchTerminationReasons,
  terminateDriver: terminateDriver,
  reactivateDriver: reactivateDriver
};

export {
  TerminationRepo ,
  
}
/* TerminationRepoConfig Not a pure module */
